import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CprValidatorComponent } from './components/cpr-validator.component';
import { TopbarModule } from '../topbar/topbar.module';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { InputModule } from '../input/input.module';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PageLoaderModule } from '../pageloader/pageloader.module';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
    declarations: [CprValidatorComponent],
    exports: [CprValidatorComponent],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        TopbarModule,
        MatInputModule,
        MatSelectModule,
        InputModule,
        FormsModule,
        MatFormFieldModule,
        PageLoaderModule,
        NgxMaskModule.forRoot(),
    ],
})
export class CprValidatorModule {}
